import type { ReactElement } from "react";
import ActualQuantityField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ActualQuantityField";
import ATCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATCField";
import ATSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATSField";
import Attachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/Attachment";
import ETCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETCField";
import ETSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETSField";
import ExternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ExternalNotesAndAttachments";
import InternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/InternalNotesAndAttachments";
import NotesField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/NotesField";
import RejectionReasonAndAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/RejectionReasonAndAttachment";
import ServiceReportAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ServiceReportAttachment";
import type { PortServiceFlowStep } from "@features/vessel-call/vessel-call-status/PortServices/flow/waste-disposal/utils";
import type { ChangeStatusDrawerInfo } from "@features/vessel-call/vessel-call-status/PortServices/hoc/withDrawers";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}

type ExtraFieldRenderer = (props: ExtraFieldProps) => ReactElement;

const extraFieldsMap: Record<string, ExtraFieldRenderer> = {
  internalNotes: () => <InternalNotesAndAttachmentsComponent />,
  externalNotes: () => <ExternalNotesAndAttachmentsComponent />,
  rejectionReason: () => <RejectionReasonAndAttachment />,
  notes: () => <NotesField />,
  attachment: () => <Attachment isPdfonly={true} />,
  ats: (props: ExtraFieldProps) => <ATSField {...props} />,
  ets: (props: ExtraFieldProps) => <ETSField {...props} />,
  etc: (props: ExtraFieldProps) => <ETCField {...props} />,
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  actualQuantity: (props: ExtraFieldProps) => <ActualQuantityField {...props} />,
  serviceReportAttachment: () => <ServiceReportAttachment />,
};

type DebunkeringExtraFieldsProps = {
  currentFlowStep: PortServiceFlowStep | null;
  selectedStatus: string;
} & ExtraFieldProps;

const DebunkeringExtraFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: DebunkeringExtraFieldsProps) => {
  return (
    <div className="flex flex-col gap-2">
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];

              if (!FieldComponent) return null;

              return (
                <div className="mt-4" key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default DebunkeringExtraFields;
